import {VenueDTO} from '@domain/venue/venue.dto';
import {PersonGender, RecurringUnit} from '@domain/common/common';

export interface ActivityScheduleDTO extends ScheduleVenue, ScheduleTime, ScheduleAudience, ScheduleOptions {
  id: string;

  lastUpdated?: string;
  lastUpdates?: string[] | null;
}

export interface CreateScheduleRequest extends ScheduleTime, ScheduleAudience, ScheduleOptions {
  venueId?: string | null; // TODO: refactor service to accept a Venue DTO (uniformize)
}
export type UpdateScheduleRequest = Partial<CreateScheduleRequest>;

export interface ScheduleVenue {
  venue?: VenueDTO | null;
}

export interface ScheduleTime {
  recurringUnit?: RecurringUnit | null;
  startDay?: number | null;
  startTime?: string | null;
  duration?: string | null;
  validFrom?: string | null;
  validUntil?: string | null;
}

export interface ScheduleAudience {
  // id?: string;
  minAge?: number | null | undefined;
  maxAge?: number | null | undefined;
  gender?: PersonGender | null;
  level?: ActivityScheduleLevel | null;
}

export interface ScheduleOptions {
  hasSupervisor?: boolean | null;
  description?: string | null;
}

export enum ActivityScheduleLevel {
  All = 'All',
  Beginner = 'Beginner',
  Intermediate = 'Intermediate',
  Advanced = 'Advanced'
}
